import { hasPageKey, normalizeAllowedPages } from './pageKeys';

// Roles allowed by the route in App.tsx; entries without a list are open to every role
const STAFF = ['admin', 'bayi', 'personel'];
const ADMIN = ['admin'];

// Where a user lands after login or when sent away from a page they cannot open: the first page in
// this fixed priority that their role and allowed_pages grant. The order of allowed_pages never matters.
const LANDING_PAGES: [string, string, string[]?][] = [
  ['/dashboard', 'dashboard', STAFF],
  ['/google-ads', 'google-ads', STAFF],
  ['/google-ads/campaigns', 'google-ads-campaigns', STAFF],
  ['/google-ads/ad-groups', 'google-ads-ad-groups', STAFF],
  ['/google-ads/keywords', 'google-ads-keywords', STAFF],
  ['/google-ads/ads', 'google-ads-ads', STAFF],
  ['/google-ads/search-terms', 'google-ads-search-terms', STAFF],
  ['/google-ads/conversions', 'google-ads-conversions', STAFF],
  ['/google-ads/insights', 'google-ads-insights', STAFF],
  ['/google-ads/alerts', 'google-ads-anomalies', STAFF],
  ['/google-ads/budget-pacing', 'google-ads-budget-pacing', STAFF],
  ['/google-ads/reports', 'google-ads-reports', STAFF],
  ['/google-ads/dashboards', 'google-ads-dashboards', STAFF],
  ['/google-ads/assistant', 'google-ads-assistant', STAFF],
  ['/google-ads/ai-analysis', 'google-ads-ai-analysis', STAFF],
  ['/waha', 'waha'],
  ['/waha/chat', 'waha-chat'],
  ['/waha/support-tickets', 'waha-conversations'],
  ['/waha/contacts', 'waha-contacts-hub'],
  ['/waha/departments', 'waha-departments'],
  ['/waha/group-tracker', 'group-tracker', STAFF],
  ['/waha/automation', 'waha-automation'],
  ['/waha/ai-assistant', 'waha-ai-assistant'],
  ['/waha/bulk', 'waha-bulk'],
  ['/templates', 'templates-hub', STAFF],
  ['/messages', 'messages', STAFF],
  ['/wa-business/numbers', 'wa-business-numbers', STAFF],
  ['/wa-business/ai-assistant', 'wa-business-ai-assistant', STAFF],
  ['/whatsapp-contacts', 'whatsapp-contacts', STAFF],
  ['/social/inbox', 'social-inbox', STAFF],
  ['/social/comments', 'social-comments', STAFF],
  ['/social/connections', 'social-connections', STAFF],
  ['/social/ai-assistant', 'social-ai-assistant', STAFF],
  ['/mail/dashboard', 'mail-dashboard'],
  ['/mail/domains', 'mail-domains'],
  ['/mail/accounts', 'mail-accounts'],
  ['/mail/delivery', 'mail-queue'],
  ['/mail/customer-packages', 'mail-allocations', STAFF],
  ['/mail/infrastructure', 'mail-bayi-quotas', ADMIN],
  ['/ai-assistant/management', 'ai-assistant-management', STAFF],
  ['/campaigns', 'campaigns', STAFF],
  ['/email-campaigns', 'email-campaigns', STAFF],
  ['/email-lists', 'email-lists', STAFF],
  ['/sms-campaigns', 'sms-campaigns', STAFF],
  ['/media', 'media', STAFF],
  ['/analytics', 'analytics', STAFF],
  ['/analiz-leads', 'analiz-leads', STAFF],
  ['/customers', 'customers', STAFF],
  ['/requests', 'requests', STAFF],
  ['/bug-reports', 'bug-reports'],
  ['/activity-logs', 'activity-logs', STAFF],
  ['/users', 'users-hub'],
  ['/settings', 'settings', STAFF],
];

export function landingPath(user: any): string {
  if (user?.username === 'google-ads-demo') return '/google-ads';
  const allowedPages = normalizeAllowedPages(user?.allowed_pages);
  if (allowedPages && allowedPages.length > 0) {
    const entry = LANDING_PAGES.find(([, key, roles]) =>
      (!roles || roles.includes(user?.role)) && hasPageKey(allowedPages, key));
    return entry ? entry[0] : '/login';
  }
  // Musteri with no allowed_pages: default to mail domains
  if (user?.role === 'musteri') return '/mail/domains';
  return '/dashboard';
}
